<template>
  <div>
    <h2>{{ getTranslations.home_games_left_special }}</h2>
    <p>{{ getTranslations.home_games_left_play_live_against }}</p>
    <p>{{ getTranslations.home_games_left_the_winner_of }}</p>
    <div class="new_game_buttons_section celebrity">
      <div class="celebrity_image">
        <img src="static/images/celebrity.svg" alt="">
      </div>
      <div class="bonus_phase_timer celebrity">
        <div class="challenge_btn">
          <a style="cursor:pointer" class="btn2 btn--v2 btn2--medium btn2--green" @click.prevent="playWithCelebrity()">
            {{ getTranslations.home_games_play_now }}
          </a>
        </div>
        <h1>{{ counter }}</h1>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import Vue from 'vue';
import RequestForRematch from '@/common/mixins/extraRematchInfo';
import ChecksToStartNewGameWithCelebrity from '@/common/mixins/rematch/celebrityMatchValidations';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});


export default {
  name: 'celebrity',
  mixins: [RequestForRematch, ChecksToStartNewGameWithCelebrity],
  data() {
    return {
      timer: 0,
      counter: 0,
    };
  },
  created() {
    const interval = 1000; // every 1 second
    let duration;
    // get time element
    // calculate difference between two times
    const eventTime = moment(this.celebrityInfo.end);
    // loop to countdown every 1 second
    this.timer = setInterval(() => {
      // based on time set in user's computer time / OS
      const currentTime = moment(new Date());
      // get duration between two times
      duration = moment.duration(eventTime.diff(currentTime));
      // get updated duration
      duration = moment.duration(duration - interval, 'milliseconds');

      // if duration is >= 0
      if (currentTime.isAfter(eventTime)) {
        clearInterval(this.timer);
        // hide the countdown element
        this.counter = '';
        this.updateCelebrityInfo(null);
      } else {
        // otherwise, show the updated countdown
        this.counter = `${duration.hours()} : ${duration.minutes()} : ${duration.seconds()}`;
      }
    }, interval);
  },
  methods: {
    ...mapActions('game', [
      'matchingWithUser',
    ]),
    ...mapMutations('profile', [
      'updateCelebrityInfo',
    ]),
    playWithCelebrity() {
      this.checkGameValidationsForCelebrity(); // play with celebrity
    },
  },
  computed: {
    ...mapState('profile', [
      'celebrityInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/Celebrity.vue